export default __webpack_public_path__ + "static/media/eraser.9614cbec.svg";